import {
    getAnswers,
    getChecklist,
    getScores,
    listMaintenance,
} from '~/api/assessment'
import type {
    ChecklistItem,
    ItemScore,
    MaintenanceEvent,
    SurveyAnswer,
} from '~/api/types'

export type MaintenanceAssessmentContext = {
    checklist: ChecklistItem[]
    answers: SurveyAnswer[]
    scores: ItemScore[]
}

/** 유지하기 변경 이력을 조회한다. */
export function loadMaintenanceHistory(
    assessmentId: string
): Promise<MaintenanceEvent[]> {
    return listMaintenance(assessmentId)
}

/** 영향 분석 상세 표시에 필요한 체크리스트, 답변, 점수를 함께 조회한다. */
export async function loadMaintenanceAssessmentContext(
    assessmentId: string
): Promise<MaintenanceAssessmentContext> {
    const [checklist, answers, scores] = await Promise.all([
        getChecklist(assessmentId).catch(() => []),
        getAnswers(assessmentId).catch(() => []),
        getScores(assessmentId).catch(() => []),
    ])

    return { checklist, answers, scores }
}
